<template>
<div id="profile" class="">
    <!-- {{profile}} -->

    <div
      class="bg-containter bc-black d-f fd-c"
      :class="{ 'has-cover': profileData.coverImg }"
      :style="profileData.coverImg ? { backgroundImage: `url(${profileData.coverImg})` } : {}"
    >

        <!-- Ticker -->
        <div class="ticker w-100 d-f jc-c" v-show="!loading && !profileData.coverImg">
            <TickerText :key="marqueeKey" :repeat="12" :paused="false" :pause-on-hover="false">
                <h1 class="ws-pre tt-up text-outline">
                    <!-- <span class="m-r" v-if="locsRank">{{locsRank.slice(-1)[0].loc}} #{{locsRank.slice(-1)[0].rank}} </span> -->

                    <span v-if="hasRankLocations">
                    <span class="m-r" v-for="(x, i) in locsRank" :key="i">
                        {{ x.loc }} #{{ x.rank }}
                    </span>
                    </span>
                    <span v-else-if="profileLocations.length">
                    <span class="m-r" v-for="(loc, i) in profileLocations" :key="i">
                        {{ loc }} <span class="grey">#0</span>
                    </span>
                    </span>
                    <span v-else>Unranked artist <span class="grey">#0</span></span>
                </h1>
            </TickerText>
        </div>

        <!-- Col Wrap -->
        <div class="col-wrap1 d-f grey tt-up p-l p-r g ai-fe jc-fe">
            <div class="col-1 d-f flex-1">
                <p class="grey hide-mob">{{ profileData.username }}</p>
            </div>
            <div class="col-2 d-f flex-1">
                <p class="hide-mob">Links</p>
            </div>
            <div class="col-3 d-f flex-1">
                <router-link
                  v-if="isOwnProfile"
                  to="/settings"
                  class="profile-img d-f jc-c ai-c img-big p-a img-border pointer"
                >
                    <img class="b-r-100" v-if="profileImg" :src="profileImg" />
                    <div v-else><PlaceholderImg /></div>
                </router-link>
                <div
                  v-else
                  class="profile-img d-f jc-c ai-c img-big p-a img-border"
                >
                    <img class="b-r-100" v-if="profileImg" :src="profileImg" />
                    <div v-else><PlaceholderImg /></div>
                </div>
            </div>
            <div class="col-4 d-f flex-1 jc-fe">
                <p class="hide-mob">Genres</p>
            </div>
            <div class="col-5 d-f flex-1 jc-fe">
                <p class="hide-mob">Rank</p>
            </div>
        </div>

    </div>

    <!-- Info Wrap Desktop -->
    <div class="info-wrap-desktop d-f fd-c ai-c hide-mob">
      <div class="col-wrap2 d-f grey tt-up p-l p-r g w-100 bs-bb">
          <div class="col-1 d-f flex-1 fd-c">
              <p class="grey hide-desk">{{ profileData.username }}</p>
              <div class="d-f fd-c">
                  <a v-if="!isOwnProfile" @click="follow"
                  >{{ isFollowing ? "Unfollow" : "Follow" }}
                  <span class="grey">{{ isFollowing ? "-1" : "+1" }}</span></a
                  >
                  <a @click="$emit('openUsersList', { followers })">
                  Followers <span class="grey">{{ followers.length }}</span>
                  </a>
                  <a @click="$emit('openUsersList', { followings })">
                  Following <span class="grey">{{ followings.length }}</span>
                  </a>
              </div>  
          </div>
          <div class="col-2 d-f flex-1 fd-c">
              <p class="hide-desk">Links</p>
              <div class="d-f fd-c" v-if="getLinks">
              <div class="links d-f fd-c" v-for="(link, i) in getLinks" :key="i">
                  <a :href="normalizeLinkUrl(link.url)" target="_blank" class="links-link d-f ai-c">{{ link.label }}<IconBase :w="10" :h="10"><IconArrowUpRight /></IconBase></a>
              </div>
              </div>
              <div class="d-f fd-c o-5" v-else><p>—</p></div>
          </div>
          <div class="col-3 d-f flex-1">
            <div class="divider hide-desk"></div>
          </div>
          <div class="col-4 d-f flex-1 fd-c ai-fe">
              <p class="hide-desk">Genres</p>
              <div v-if="getGenres.length" class="d-f fd-c ai-fe">
                <p class="ta-r white" v-for="(genre, i) in getGenres" :key="i">
                  <router-link :to="{ path: `/music/genre-${genre}` }">
                  {{ genre }}
                  </router-link>
                </p>
              </div>
              <p class="ta-r o-5" v-else>—</p>
          </div>
          <div class="col-5 d-f flex-1 fd-c ai-fe">
            <p class="hide-desk">{{ hasRankLocations ? 'Rank' : 'Location' }}</p>
            <div v-if="hasRankLocations">
                <div
                class="d-f fd-c ai-fe"
                v-for="(x, i) in locsRank.slice().reverse()"
                :key="i"
                >
                <a class="ta-r">
                    <router-link :to="{ path: `/artists/${x.loc}` }">{{
                    x.loc
                    }}</router-link>
                    <span> #{{ x.rank }}</span>
                </a>
                </div>
            </div>
            <div v-else-if="profileLocations.length" class="d-f fd-c ai-fe">
                <p class="ta-r" v-for="(loc, i) in profileLocations" :key="i">
                    <router-link :to="{ path: `/artists/${loc}` }">{{ loc }}</router-link>
                    <span class="grey"> #0</span>
                </p>
            </div>
            <div class="d-f fd-c" v-else><p>—</p></div>
          </div>
      </div>
      <!-- Title Wrap -->
      <div class="title-wrap d-f fd-c ai-c jc-c w-100 p-lg bs-bb">
          <img v-if="profileData.logoImg" :src="profileData.logoImg" class="profile-logotype" :alt="profileData.username" />
          <h3 v-else>{{ profileData.username }}</h3>
      </div>
    </div>

    <!-- Info Wrap Mobile -->
    <div class="info-wrap-mobile d-f fd-c ai-c hide-desk">
      <!-- Title Wrap -->
      <div class="title-wrap d-f fd-c ai-c jc-c w-100 p-lg bs-bb">
          <img v-if="profileData.logoImg" :src="profileData.logoImg" class="profile-logotype" :alt="profileData.username" />
          <h3 v-else>{{ profileData.username }}</h3>
      </div>
      <div class="col-wrap2 d-f grey tt-up p-l p-r g w-100 bs-bb">
        <div class="col-inner-left d-f fd-c flex-1">
          <div class="col-1 d-f fd-c">
              <p class="grey">{{ profileData.username }}</p>
              <div class="d-f fd-c">
                  <a v-if="!isOwnProfile" @click="follow"
                  >{{ isFollowing ? "Unfollow" : "Follow" }}
                  <span class="grey">{{ isFollowing ? "-1" : "+1" }}</span></a
                  >
                  <a @click="$emit('openUsersList', { followers })">
                  Followers <span class="grey">{{ followers.length }}</span>
                  </a>
                  <a @click="$emit('openUsersList', { followings })">
                  Following <span class="grey">{{ followings.length }}</span>
                  </a>
              </div>  
          </div>
          <div class="col-2 d-f fd-c">
              <p>Links</p>
              <div class="d-f fd-c" v-if="getLinks">
                <div class="links d-f fd-c" v-for="(link, i) in getLinks" :key="i">
                    <a :href="normalizeLinkUrl(link.url)" target="_blank" class="links-link d-f ai-c g-half">{{ link.label }}<IconBase :w="10" :h="10"><IconArrowUpRight /></IconBase></a>
                </div>
              </div>
              <div class="d-f fd-c o-5" v-else><p>—</p></div>
          </div>
        </div>
          <div class="col-3 d-f">
            <div class="divider"></div>
          </div>
        <div class="col-inner-right d-f fd-c ai-fe flex-1">
          <div class="col-4 d-f fd-c ai-fe">
              <p>Genres</p>
              <div v-if="getGenres.length" class="d-f fd-c ai-fe">
                <p class="genres ta-r" v-for="(genre, i) in getGenres" :key="i">
                  <router-link :to="{ path: `/music/genre-${genre}` }">
                  {{ genre }}
                  </router-link>
                </p>
              </div>
              <p class="genres ta-r o-5" v-else>—</p>
          </div>
          <div class="col-5 d-f fd-c ai-fe">
            <p>{{ hasRankLocations ? 'Rank' : 'Location' }}</p>
            <div v-if="hasRankLocations">
                <div
                class="d-f fd-c ai-fe"
                v-for="(x, i) in locsRank.slice().reverse()"
                :key="i"
                >
                <a class="ta-r">
                    <router-link :to="{ path: `/artists/${x.loc}` }">{{
                    x.loc
                    }}</router-link>
                    <span> #{{ x.rank }}</span>
                </a>
                </div>
            </div>
            <div v-else-if="profileLocations.length" class="d-f fd-c ai-fe">
                <p class="ta-r" v-for="(loc, i) in profileLocations" :key="i">
                    <router-link :to="{ path: `/artists/${loc}` }">{{ loc }}</router-link>
                    <span class="grey"> #0</span>
                </p>
            </div>
            <div class="d-f fd-c" v-else><p>—</p></div>
          </div>
        </div>
      </div>
    </div>

    <div class="d-f jc-c hide-mob">
        <div class="vert-divider"></div>
    </div>

    <!-- Submit Demo Card -->
    <div class="d-f fd-c ai-c p-hor m-t-lg">
      <SubmitDemoCard
        v-if="profileData.acceptingSubmissions"
        :label-uid="uid"
        :label-data="profileData"
        :recipient-type="'artist'"
        :demo-criteria="profileData.demoCriteria"
      />
    </div>

    <!-- Songs Playlist -->
    <div class="d-f fd-c ai-c">
        <SongsPlaylistProfile
            :playlist-position="0"
            @play-select-song="playSelectedSongAsync"
            :playlist="uploadsList"
            :is-own-profile="isOwnProfile"
            :artist-handle="profileData.usernameUrl"
        >
        </SongsPlaylistProfile>
    </div>

    <!-- Events -->
    <div class="d-f fd-c ai-c p-hor p-ver-lg">
      <EventsSection v-if="uid" :user-id="uid" />
    </div>

    <!-- Links -->
    <div class="d-f fd-c ai-c p-hor p-ver-lg">
      <LinksSection v-if="uid" :user-id="uid" />
    </div>

</div>
  </template>
  
  <script>
  import { auth, rtdb } from "@/db.js";
  import { sanitizeKey } from "@/utils/helpers.js";
  import { mapGetters, mapActions } from "vuex";
  import PlayerMixin from "@/mixins/PlayerMixin";
  import { isMobileMixin } from "@/mixins/isMobileMixin";
  import SongsPlaylistProfile from "@/components/profile/SongsPlaylistProfile";
  import TickerText from "@/components/misc/TickerText.vue";
  import PlaceholderImg from "@/assets/icons/PlaceholderImg.vue";
  import SubmitDemoCard from "@/components/demos/SubmitDemoCard.vue";
  import EventsSection from "@/components/profile/EventsSection.vue";
  import LinksSection from "@/components/profile/LinksSection.vue";
  import IconBase from "@/assets/icons/IconBase.vue";
  import IconArrowUpRight from "@/assets/icons/IconArrowUpRight2.vue";

  export default {
    name: "Profile",
    props: ["profileData", "uid", "loading", "isOwnProfile"],
  components: {
    SongsPlaylistProfile,
    TickerText,
    PlaceholderImg,
    SubmitDemoCard,
    EventsSection,
    LinksSection,
    IconBase,
    IconArrowUpRight,
  },
    mixins: [PlayerMixin, isMobileMixin],
    data() {
      return {
        uploadsList: {
          title: "Profile music jahdkjwah",
          songs: null,
        },
        marqueeKey: 0, // Key to force reinitialization
        locsRank: [], // Initialize as an empty array
        // locsRank: null
      };
    },
    mounted() {
      this.getUploads();
      this.getProfileRank();
      this.$nextTick(() => {
        this.marqueeKey++; // Force reinitialization after DOM is updated
      });
    },
    watch: {
      uid() {
        this.getProfileRank();
      },
      profileData: {
        deep: true,
        handler() {
          this.getProfileRank();
        },
      },
    },
    computed: {
      ...mapGetters(["getUser", "getUserSettings", "getPlayerHidden"]),
      profileImg() {
        if (this.profileData.profileImg) {
          return this.profileData.profileImg;
        } else {
          return false;
        }
      },
      getLinks() {
        if (!this.profileData.links) return false;
        const platformLabels = {
          spotify: 'Spotify', soundcloud: 'SoundCloud', beatport: 'Beatport',
          bandcamp: 'Bandcamp', instagram: 'Instagram', tiktok: 'TikTok',
          twitter: 'X', youtube: 'YouTube', facebook: 'Facebook',
          twitch: 'Twitch', website: 'Website', email: 'Email',
        };
        const result = Object.entries(this.profileData.links)
          .map(([key, val]) => {
            if (typeof val === 'string') {
              // Legacy format: key is platform name, val is URL
              return { label: key, url: val };
            } else if (val && val.url) {
              // New format: { type, url, label? }
              return { label: val.label || platformLabels[val.type] || val.type, url: val.url };
            }
            return null;
          })
          .filter(Boolean);
        return result.length ? result : false;
      },
      followers() {
        return Object.entries(this.profileData.followers || {})
          .map(([key, value]) => {
            return value && key;
          })
          .filter(Boolean);
      },
      followings() {
        return Object.entries(this.profileData.followings || {})
          .map(([key, value]) => {
            return value && key;
          })
          .filter(Boolean);
      },
      isFollowing() {
        return (
          this.getUser.data?.uid && this.followers.includes(this.getUser.data.uid)
        );
      },
      getGenres() {
        if (!this.profileData?.genres) {
          return [];
        }
        // Handle both object format (gen0, gen1, etc.) and legacy comma-separated string
        const excludePlaceholders = (g) =>
          g && g !== "All" && g !== "All Genres";
        if (typeof this.profileData.genres === "string") {
          // Legacy format: comma-separated string
          return this.profileData.genres
            .split(",")
            .map((g) => g.trim())
            .filter(excludePlaceholders);
        } else if (typeof this.profileData.genres === "object") {
          // New format: object with gen0, gen1, etc.
          return Object.values(this.profileData.genres)
            .map((g) => (typeof g === "string" ? g.trim() : g))
            .filter(excludePlaceholders);
        }
        return [];
      },
      profileLocations() {
        return Object.values(this.profileData.locations || {}).filter(Boolean);
      },
      hasRankLocations() {
        return Array.isArray(this.locsRank) && this.locsRank.length > 0;
      },
    },
    methods: {
      ...mapActions(["addPlaylist", "replacePlaylist", "followUser"]),
  
      playSelectedSongAsync(payload, playlist) {
        const that = this;
        async function asyncFunc() {
          await that.replacePlaylist({
            title: "Teeeeeesting",
            songs: that.uploadsList.songs,
          });
          that.playSelectedSong(payload);
          console.log(payload);
        }
        return asyncFunc();
      },
  
      getUploads() {
        const userUid = this.uid;
        const usersMusicRef = rtdb.ref(`userMusic/${userUid}`);
        usersMusicRef.on("value", (snapshot) => {
          const arr = [];
          snapshot.forEach((x) => {
            arr.push(x.val());
          });
          this.$set(this.uploadsList, "songs", arr);
        });
      },
      getImg(x) {
        if (x) {
          return x;
        } else {
          return "https://upload.wikimedia.org/wikipedia/commons/thumb/6/65/No-Image-Placeholder.svg/1200px-No-Image-Placeholder.svg.png";
        }
      },
      getProfileRank() {
        const userUid = this.uid;
        if (!userUid) {
          this.locsRank = [];
          return;
        }
        const locations = this.profileData?.locations || {};
        const levels = ["loc0", "loc1", "loc2", "loc3", "loc4", "loc5"];
        rtdb
          .ref(`rankProfiles/${userUid}/ranks`)
          .once("value")
          .then((snapshot) => {
            const ranks = snapshot.val();
            const localArr = [];
            if (ranks && typeof ranks === "object") {
              levels.forEach((level) => {
                const raw = locations[level];
                if (!raw) return;
                const rankKey = `${level}_${sanitizeKey(raw)}`;
                const rankVal = ranks[rankKey];
                if (rankVal != null && rankVal !== "") {
                  const n = Number(rankVal);
                  if (!Number.isNaN(n)) {
                    localArr.push({ loc: raw, rank: n });
                  }
                }
              });
            }
            this.locsRank = localArr;
            this.$nextTick(() => {
              this.marqueeKey++;
            });
          })
          .catch(() => {
            this.locsRank = [];
          });
      },
  
      normalizeLinkUrl(url) {
        if (!url || typeof url !== "string") return "#";
        const trimmed = url.trim();
        if (!trimmed) return "#";
        if (/^https?:\/\//i.test(trimmed)) return trimmed;
        return `https://${trimmed}`;
      },

      follow() {
        if (!this.getUser.data?.uid) {
          this.$store.dispatch("togglePopMess", "You must login to Follow");
          return;
        }
        const wasFollowing = this.isFollowing;
        this.followUser({
          uid: this.uid,
          type: "artist",
          status: !wasFollowing,
        });
        const message = wasFollowing
          ? "Unfollowed profile"
          : "Following profile";
        this.$store.dispatch("togglePopMess", message);
      },
    },
  };
  </script>
  <style lang="scss" scoped>
  @import "@/scss/_variables.scss";
  @import "@/scss/_classes.scss";
  @import "@/scss/_mixins.scss";
  #profile {
    overflow-x: hidden;
    .bg-containter {
      height: 50vh;
      justify-content: flex-end;
      position: relative;
      overflow: visible;

      &.has-cover {
        background-size: cover;
        background-position: center;

        @media #{$large-screen} {
          &::after {
            content: '';
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            height: 60%;
            background: linear-gradient(to bottom, transparent, rgba(0, 0, 0, 0.7));
            pointer-events: none;
            z-index: 1;
          }

          .col-wrap1 {
            position: relative;
            z-index: 2;
          }
        }
      }
      .col-wrap1 {
        .col-1, .col-2, .col-4, .col-5 {
            padding-bottom: calc($mg-desktop / 2);
        }
        .col-3 {
        //This is to center the profile image in the column-3
          position: relative;
          display: flex;
          justify-content: center;
          .profile-img {
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translate(-50%, 50%);
            z-index: 10;
          }
        }
      }
    }
    .info-wrap-desktop {
      .col-wrap2 {
        padding-top: calc($mg-desktop / 2);
        min-height: calc($img-l-d / 2);
        @media #{$mobile} {
          margin-top: calc($img-l-m / 2);
        }
      }
    }
    .info-wrap-mobile {
      margin-top: calc($img-l-m / 2);
      .col-wrap2 {
        padding-top: calc($mg-mobile / 2);
        min-height: calc($img-l-m / 2);
        .divider {
            width: 1px;
            height: 100%;
            background-color: $line-color;
        }   
        .col-1, .col-4 {
            padding-bottom: $mg-mobile;
        }
      }
    }
    .playermargin {
      margin-bottom: 70px;
    }
    .ticker {
      position: absolute;
      top: 50%;
      left: 0;
      right: 0;
      transform: translateY(-50%);
      z-index: 0;
      // TickerText component handles overflow and animation
      h1 {
        padding: 20px 0;
        display: inline-block;
        @media #{$mobile} {
          font-size: $h1-xl-m;
        }
      }
    }
    .vert-divider {
      width: 1px;
      height: 80px;
      background-color: $line-color;
    }
    .profile-logotype {
      max-width: 240px;
      max-height: 80px;
      width: auto;
      height: auto;
      display: block;

      @media #{$mobile} {
        width: 40vw;
      }
    }
  }
  .links-link {
    gap: 3px;
  }
  a.links-link ::v-deep g {
    stroke: $grey !important;
    transition: stroke 0.15s;
  }
  a.links-link:hover ::v-deep g {
    stroke: $white !important;
  }
  </style>
  